<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i class="fal fa-check-double dialog-icon"></i>
            <span class="te-title">{{'enquiryBook.duplicateEnquiry' | translate}}</span>
        </div>
        <div class="td-cnt-body">
            <span>{{message}} <b>{{enquiryNo}}</b></span>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onEditEnquiryClick()" class="mr-5" [text]="'enquiryBook.editEnquiry' | translate"  [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseDuplicateModalClick()" class="mr-5" [type]="'tb-cancel'" [text]="'commons.close' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
